import { render, staticRenderFns } from "./SplitAssignment.vue?vue&type=template&id=6cec0293&scoped=true"
import script from "./SplitAssignment.vue?vue&type=script&lang=js"
export * from "./SplitAssignment.vue?vue&type=script&lang=js"
import style0 from "./SplitAssignment.vue?vue&type=style&index=0&id=6cec0293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec0293",
  null
  
)

export default component.exports